export default __webpack_public_path__ + "static/media/construction.9a087e0a.svg";